<div mat-dialog-content>
	現在のデータを破棄して新規作成します。<br />よろしいですか？
</div>
<div mat-dialog-actions>
	<button mat-raised-button mat-dialog-close>いいえ</button>
	<button mat-raised-button color="warn" (click)="clearform()">
		はい
	</button>
</div>
